import { Button, Text } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
const EmptyState = ({
  heading,
  text,
  redirect,
  btnName,
  img = `empty-state.svg`,
}) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate(redirect);
  };
  return (
    <>
      <div
        style={{
          marginTop: "100px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/${img}`} alt="Empty State" />
          <br />
          <Text variant="headingLg">{heading}</Text>
          <br />
          <Text variant="bodyMd">{text}</Text>
          <br />
          {btnName ? (
            <Button onClick={handleNavigate} variant="primary">
              {btnName}
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default EmptyState;
